
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { ProjectPageVariation } from '~/types/sanity-documents';
import NftCardLayout from './NftCardLayout.vue';

@Component({
  components: { NftCardLayout },
})
export default class NftCardSkeletonLoader extends Vue {
  @Prop(String) readonly colLayoutBp!: 'sm' | 'md' | 'lg';

  get shouldUse2ColLayout() {
    const variation =
      this.$sanityLookup.getSiteConfig()?.data?.projectPageVariation;
    return variation === ProjectPageVariation.V2;
  }
}
